// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"119":"c9ede101","453":"325811f2","853":"2d56b45b"}[chunkId] + ".chunk.js";
};